import { styled, Box, IconButton, Button } from '@mui/material';
import { darken } from '@mui/material/styles';

export const DashboardVariantV2GiverConnectYourStoreBannerContainer = styled(
  Box,
)(({ theme }) => ({
  backgroundColor: '#00FFFF',
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 5, 2, 25),
  borderRadius: 12,
  justifyContent: 'space-between',
  position: 'relative',
  minHeight: 122,
}));

export const DashboardVariantV2GiverConnectYourStoreBannerImage = styled('img')(
  {
    position: 'absolute',
    height: 122,
    width: 178,
    objectFit: 'contain',
    top: 0,
    left: 0,
  },
);

export const DashboardVariantV2GiverConnectYourStoreBannerCloseButton = styled(
  IconButton,
)({
  position: 'absolute',
  right: 4,
  top: 4,
});

export const DashboardVariantV2GiverConnectYourStoreBannerActionButton = styled(
  Button,
)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  backgroundColor: theme.palette.common.white,

  '&:hover': {
    backgroundColor: darken(theme.palette.common.white, 0.2),
  },
}));
